module["exports"] = [
  "co.uk",
  "com",
  "biz",
  "info",
  "name"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_GB/internet/domain_suffix.js
// module id = 2150
// module chunks = 2